module.exports = __webpack_public_path__ + "media/images/pic/home/owners-405fe4e71f03d0e5cde672af5f4384c2.png";